import { useTheme } from "../store/use-theme";
import logoDark from "../assests/debtsure_logo_dark.png";
import logoLight from "../assests/debtsure_logo_light.png";

type Props = { className?: string; alt?: string };

export default function BrandedLogo({
  className = "",
  alt = "DebtSure",
}: Props) {
  const theme = useTheme((s) => s.theme);
  return (
    <img
      src={theme === "dark" ? logoDark : logoLight}
      alt={alt}
      className={className}
    />
  );
}
